import FileSaver from 'file-saver'
import ContentDisposition from 'content-disposition'
import ReportsService from '@/services/ReportsService';
import { i18n } from "@/i18n";

export default {
  methods: {
    downloadFile: function(response) {
      let disposition = ContentDisposition.parse(response.headers['content-disposition']);

      if (disposition && disposition.parameters && disposition.parameters.filename)
        FileSaver.saveAs(response.data, disposition.parameters.filename);
      else
        FileSaver.saveAs(response.data);
    },

    downloadReportForSurveyInstance(surveyInstanceId) {
      ReportsService.getCheckReport(
        surveyInstanceId,
        { localizationId: i18n.locale })
        .then(response => {
          this.downloadFile(response);
        })
        .catch(_ => {
          this.$bvToast.toast(
            this.$t("Webportal.CX.Margin.CheckReportErrorMessage"),
            {
              title: this.$t("Webportal.CX.Margin.CheckReportErrorTitle"),
              autoHideDelay: 5000,
              variant: "danger",
              noCloseButton: true,
            }
          );
        } 
      )
    },

    getFileIcon(fileName) {
      return fileName.match(/.(pdf)$/i)
        ? "file-pdf"
        : fileName.match(/.(doc|dot|docx|docm|dotx|docb|rtf)$/i)
        ? "file-word"
        : fileName.match(/.(jpg|jpeg|png|gif)$/i)
        ? "file-image"
        : fileName.match(/.(xls|xlt|xlm|xlsx|xlsm|xltx|xltm)$/i)
        ? "file-excel"
        : fileName.match(
            /.(ppt|pot|pps|pptx|pptm|potx|potm|ppam|ppsx|ppsm|sldx|sldm)$/i
          )
        ? "file-powerpoint"
        : fileName.match(
            /.(webm|mpg|mp2|mpeg|mpe|mpv|mp4|m4p|m4v|avi|mkv|wmv|mov|qt|flv|swf)$/i
          )
        ? "file-video"
        : fileName.match(/.(m4a|flac|mp3|ogg|wav|wma|aac|mid)$/i)
        ? "file-audio"
        : "file";
    },
  }
}